import { render, staticRenderFns } from "./GroupConfig.vue?vue&type=template&id=8d4aa1b0&scoped=true&"
import script from "./GroupConfig.vue?vue&type=script&lang=js&"
export * from "./GroupConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d4aa1b0",
  null
  
)

export default component.exports